
import { Component, Vue } from 'vue-property-decorator'
import CommonPopup from '../../../components/CommonPopup.vue';

@Component({
    components: {CommonPopup}
})
export default class PrivacyPolicy extends Vue{

}
